export var OFFER_STATUSES = [
    "ACTIVE",
    "ACCEPTED",
    "REJECTED",
    "CANCELLED",
    "EXPIRED",
];
